export const realizedProfitAndLossTooltip = {
    title: 'Realized P&L',
    body: 'is the profit/loss of the executed portion of the order compared to the chosen benchmark.',
};
export const unrealizedProfitAndLossTooltip = {
    title: 'Unrealized P&L',
    body: 'is the profit/loss of the remaining unexecuted portion of the order compared to the chosen benchmark.',
};
export const totalProfitAndLoss = {
    title: 'Total P&L',
    body: 'represents the sum of Realized (executed portion of order) P&L and Unrealized (unexecuted portion) P&L. Unrealized P&L uses the last traded price as an indicative price for any unfilled shares.',
};
export const estCostTooltip = {
    title: 'Estimated Impact Cost',
    body: 'is the estimated cost of executing a trade as calculated by our cost model (based on characteristics such as order size, spread, volatility, volume profiles, country and market cap).',
};
